import { mapActions, mapGetters, mapState } from 'vuex';
import { UX_OPTIONS_BUTTON_COLOR_SCHEME, UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT } from '@/components/account/settings/settings';
import whatIsNewFlowVersion1Mixin from './mixin';


export default {
  mixins: [
    whatIsNewFlowVersion1Mixin,
  ],
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('whatisnew', ['optionSecondStepSelectedFlow1', 'optionThirdStepSelectedFlow1']),
    optionsSecondStep() {
      return UX_OPTIONS_BUTTON_COLOR_SCHEME.options;
    },
    optionsThirdStep() {
      return [...UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT.options].reverse();
    },
  },
  methods: {
    ...mapActions('whatisnew', ['selectOptionSecondStepFlow1', 'selectOptionThirdStepFlow1']),
  },
};



// WEBPACK FOOTER //
// ./src/components/what-is-new-popup/flows/what-is-new-flow-version-1/what-is-new-flow-version-1.js